import React from 'react';

import './row-break.styles.scss'

export const RowBreak = () => (

    <hr/>

)